import React, { lazy } from 'react';
import SkeletonGrid from '../../../skeleton_loaders/common/SkeletonGrid.jsx';
import withSuspense from '../../../helpers/withSuspense.jsx';
import useRowId from '../../datagrid/hooks/useRowId.js';
import { valueGetter } from './TaskDatagrid.jsx';
import { useTaskOptions } from '../hooks/useTaskOptions.js';
const HEIGHT = 'calc(100vh - 56px - 30px - 145px)';
const skeletonProps = {
  className: 'kanban-view',
  skeletonHeight: HEIGHT
}
const CommonAggridTable = withSuspense(lazy(() => import('../../common/AgGrid/CommonAggridTable.jsx')), <SkeletonGrid {...skeletonProps} />);
const TaskKanbanView = withSuspense(lazy(() => import('./TaskKanbanView.jsx')), <SkeletonGrid {...skeletonProps} />);

function TaskServerSideKanbanView({ projectId, reloadClick, presetId, permissions, baseQueryKey, advancedFeatures, programmeTasks }) {
  const {task_status_options} = useTaskOptions({projectId});
  const [_, getRowId] = useRowId();
    
  const ready = Boolean(task_status_options);

  if (!ready) return <SkeletonGrid {...skeletonProps} />;
  return (
    <TaskKanbanView
      project_id={projectId}
      presetId={presetId}
      containerStyle={{ height: HEIGHT, paddingBottom: 0 }}
      DatagridComponent={CommonAggridTable}
      permissions={permissions}
      advancedFeatures={advancedFeatures}
      gridProps={{
        gridOptions: {
          rowModelType: 'serverSide',
          getRowId,
          rowDragManaged: false,
          cacheBlockSize: 20
        }
      }}
      columnDefs={[
        {
          field: '-',
          colId: 'status',
          editable: false,
          minWidth: 90,
          width: 120,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: task_status_options.map(o => o.id)
          },
          valueGetter: valueGetter,
          hide: true
        },
        {
          field: '-',
          colId: 'global_search',
          editable: false,
          hide: true,
          lockVisible: true,
          filter: 'agTextColumnFilter',
          suppressColumnsToolPanel: true
        }
      ]}
      reloadClick={reloadClick}
      baseQueryKey={baseQueryKey}
      programmeTasks={programmeTasks}
    />
  )
}

export default TaskServerSideKanbanView;